import { createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { Dayjs } from 'dayjs';
import { getTeacherSchedule, searchTeachers } from 'entities/index';

import {
  mapTeacherSchedule,
  mapTeacherScheduleWithoutDate,
} from '../../lib/utils';
import { ITeachersState } from '../ITeachersState';

const initialState: ITeachersState = {
  teachers: [],
  teachersIsLoading: false,
  teachersError: null,

  dataForTeacherSchedule: [],
  teacherSchedule: [],
  teacherScheduleIsLoading: false,
  teacherScheduleError: null,

  teacherScheduleWithoutDate: [],
};

export const teachersSlice = createSlice({
  name: 'teachers',
  initialState: initialState,
  reducers: {
    resetTeachers: (state: ITeachersState) => {
      state.teachers = [];
    },
    resetTeacherSchedule: (state: ITeachersState) => {
      state.dataForTeacherSchedule = [];
      state.teacherSchedule = [];
    },
    setTeacherSchedule: (
      state: ITeachersState,
      action: {
        payload: {
          startDate: Dayjs;
          endDate: Dayjs;
        };
      },
    ) => {
      state.teacherSchedule = mapTeacherSchedule(
        action.payload.startDate,
        action.payload.endDate,
        state.dataForTeacherSchedule ?? [],
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchTeachers.fulfilled, (state: ITeachersState, action) => {
        state.teachers = action.payload.teachers;
        state.teachersIsLoading = false;
        state.teachersError = null;
      })
      .addCase(searchTeachers.pending, (state: ITeachersState) => {
        state.teachersIsLoading = true;
        state.teachersError = null;
      })
      .addCase(searchTeachers.rejected, (state: ITeachersState, action) => {
        state.teachers = [];
        state.teachersIsLoading = false;
        state.teachersError =
          (action.payload as AxiosError).response?.status !== 401
            ? (action.payload as AxiosError).message
            : '';
      })
      .addCase(
        getTeacherSchedule.fulfilled,
        (state: ITeachersState, action) => {
          state.dataForTeacherSchedule = action.payload.teacher_schedule;
          state.teacherSchedule = mapTeacherSchedule(
            action.payload.startDate,
            action.payload.endDate,
            action.payload.teacher_schedule ?? [],
          );
          state.teacherScheduleIsLoading = false;
          state.teacherScheduleError = null;
          state.teacherScheduleWithoutDate = mapTeacherScheduleWithoutDate(
            action.payload.teacher_schedule ?? [],
          );
        },
      )
      .addCase(getTeacherSchedule.pending, (state: ITeachersState) => {
        state.teacherScheduleIsLoading = true;
        state.teacherScheduleError = null;
      })
      .addCase(getTeacherSchedule.rejected, (state: ITeachersState, action) => {
        state.dataForTeacherSchedule = [];
        state.teacherSchedule = [];
        state.teacherScheduleIsLoading = false;
        state.teacherScheduleError =
          (action.payload as AxiosError).response?.status !== 401
            ? (action.payload as AxiosError).message
            : '';
        state.teacherScheduleWithoutDate = [];
      })
      .addDefaultCase(() => {});
  },
});
export const { resetTeachers, resetTeacherSchedule, setTeacherSchedule } =
  teachersSlice.actions;
export const teachersReducer = teachersSlice.reducer;
